<template lang="html">
  <div class="top-title-bar">
    <v-btn v-if="!hideBack" small color="primary" icon  @click.stop="$emit('back')">
      <v-icon small> mdi-arrow-left-top </v-icon>
    </v-btn>
    <div class="panel-header text-h6 pe-4" :title="title">
      {{ $truncateString(title, 18) }}
    </div>

    <v-tooltip v-if="collapsible && !collapsed" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click.stop="$emit('toggleCollapse')" small color="primary" class="model-browser-collapse-btn" title="Collapse" v-bind="attrs" v-on="on">
          <v-icon small>mdi-arrow-expand-left</v-icon>
        </v-btn>
      </template>
      <span>Collapse</span>
    </v-tooltip>

    <v-tooltip v-if="collapsible && collapsed" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click.stop="$emit('toggleCollapse')" small color="primary" class="model-browser-collapse-btn" title="Expand" v-bind="attrs" v-on="on">
          <v-icon small>mdi-arrow-expand-right</v-icon>
        </v-btn>
      </template>
      <span>Expand</span>
    </v-tooltip>
  </div>
</template>
<script>
	import { $truncateString } from '@/utils';

  export default {
    name: 'MenuTitleBar',
    props: {
      title: {
        type: String,
        default: '',
      },
      hideBack: {
        type: Boolean,
        default: false,
      },
      collapsible: {
        type: Boolean,
        default: false,
      },
      collapsed: {
        type: Boolean,
        default: false,
      },
    },
		emits: ['back', 'toggleCollapse'],
		methods: {
			$truncateString
		}
  };
</script>
<style lang="scss">
.top-title-bar {
	background-color: var(--v-bg_Greeny_Gray-base);
}
</style>
